module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page6.f529662b.png";